<template>
    <FooterImages :item-data="itemData" @openContactPopup="openContactPopup" />
    <div class="container">
        <div class="content">
            <div v-html="footerHtmlText"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, defineProps, onMounted, defineEmits } from 'vue';
import FooterImages from './footerImages.vue';
import { FooterImagesItem } from '@/view/home/supportScript';
const footerHtmlText = ref('')
const props = defineProps<{
    itemData: {
        htmlText: string,
        footerImage1: FooterImagesItem,
        footerImage2: FooterImagesItem,
        footerImage3: FooterImagesItem,
        footerImage4: FooterImagesItem,
        footerImage5: FooterImagesItem,
        htmlFooterTextTop: {
            display : boolean
            text: string
        }
    }
}>()
const emits = defineEmits(['openContactPopup'])
const openContactPopup = () => {
    emits('openContactPopup')
}
onMounted(() => {
    footerHtmlText.value = props.itemData.htmlText
})
</script>
<style scoped>
.container {
    padding: 10px 15px 50px;
    line-height: 20px;
    font-size: 11px;
    color: #86718c;
}

.container :deep(*) {
  color: #86718c !important;
}

.ql-align-center {
    text-align: center !important;
}

.ql-align-center span {
    display: inline-block;
    width: 100%;
}


.ql-align-right {
    text-align: right !important;
}

.ql-align-right span {
    display: inline-block;
    width: 100%;
}

.ql-align-left {
    text-align: left !important;
}

.ql-align-left span {
    display: inline-block;
    width: 100%;
}
</style>